import { Button, Dropdown } from "react-bootstrap";
import "./productmasterprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicatePlusIcon from "../../assets/images/duplicate-plus-icon.svg";
import { ReactSVG } from "react-svg";
import { Product } from "../../redux/product/productSlice";
import { MouseEventHandler } from "react";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../utils/permissionUtils";
interface ProductProfileHeader {
  selectedProductData: Product;
  updateStatus: any;
  toggleModal: MouseEventHandler<HTMLElement>;
  toggleDuplicateModal: MouseEventHandler<HTMLElement>;
}

const ProductMasterProfileHeader = ({
  selectedProductData,
  updateStatus,
  toggleModal,
  toggleDuplicateModal,
}: ProductProfileHeader) => {

  const isPermitted = useModulePermissions(PermissionModule.PRODUCT_MASTER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_PRODUCT_MASTER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_PRODUCT_MASTER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_PRODUCT_MASTER);

  return (
    <div className="product-master-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{selectedProductData.productName}</h2>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-product-master">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        {(isDeletePermitted || isDuplicatePermitted) && (
          <Dropdown>
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {isDeletePermitted && (
                <Dropdown.Item onClick={toggleModal}>
                  <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                  Delete
                </Dropdown.Item>
              )}
              {isDuplicatePermitted && (
                <Dropdown.Item onClick={toggleDuplicateModal}>
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={duplicatePlusIcon}
                  />
                  Duplicate
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default ProductMasterProfileHeader;
